import {createRouter, createWebHashHistory} from "vue-router";
import Sales from "../views/dashboards/Sales.vue";
import Login from "../views/Seguridad/Login.vue";
import store from "@/store";
import List_Users from "@/views/Seguridad/List_Users.vue";
import List_Groups from "@/views/Seguridad/List_Groups.vue";
import List_Permissions from "@/views/Seguridad/List_Permissions.vue";
import List_Logs from "@/views/Seguridad/List_Logs.vue";
import UserProfile from "@/views/Seguridad/UserProfile.vue";

const routes = [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/login",
        name: "Login",
        component: Login
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Sales
    },
    {
        path: "/test-vuetify",
        name: "TestVuetify",
        component: () => import("@/components/VuetifyTest.vue")
    },
    {
        path: "/seguridad/usuarios",
        name: "Usuarios",
        component: List_Users
    },
    {
        path: "/seguridad/permisos",
        name: "Permisos",
        component: List_Permissions
    },
    {
        path: "/seguridad/trazas",
        name: "Trazas",
        component: List_Logs
    },
    {
        path: "/seguridad/roles",
        name: "Roles",
        component: List_Groups
    },
    {
        path: "/perfil",
        name: "UserProfile",
        component: UserProfile
    },
    // Gestión
    {
        path: "/gestion/clientes",
        name: "GestionClientes",
        component: () => import("@/views/Gestion/List_Clients.vue")
    },
    {
        path: "/gestion/autos",
        name: "GestionAutos",
        component: () => import("@/views/Gestion/List_Cars.vue")
    },
    {
        path: "/gestion/autos/eliminados",
        name: "GestionAutosEliminados",
        component: () => import("@/views/Gestion/List_Deleted_Cars.vue")
    },
    {
        path: "/gestion/cotizaciones",
        name: "GestionCotizaciones",
        component: () => import("@/views/Gestion/List_Quotes.vue")
    },
    {
        path: "/gestion/cotizaciones/nueva",
        name: "NuevaCotizacion",
        component: () => import("@/views/Gestion/NewQuote.vue")
    },
    {
        path: "/gestion/cotizaciones/editar",
        name: "EditarCotizacion",
        component: () => import("@/views/Gestion/NewQuote.vue")
    },
    {
        path: "/gestion/cotizaciones/canceladas",
        name: "CotizacionesCanceladas",
        component: () => import("@/views/Gestion/List_Cancelled_Quotes.vue")
    },
    {
        path: "/gestion/contratos",
        name: "GestionContratos",
        component: () => import("@/views/Gestion/List_Contracts.vue")
    },
    // Vista de citas deshabilitada temporalmente - se gestionan por WhatsApp
    // {
    //     path: "/gestion/citas",
    //     name: "GestionCitas",
    //     component: () => import("@/views/Gestion/List_Appointments.vue")
    // },
    {
        path: "/gestion/gestores",
        name: "GestionGestores",
        component: () => import("@/views/Gestion/List_Managers.vue")
    },
    {
        path: "/gestion/sucursales",
        name: "GestionSucursales",
        component: () => import("@/views/Gestion/List_Branches.vue")
    },
    {
        path: "/gestion/calendario-pagos",
        name: "GestionCalendarioPagos",
        component: () => import("@/views/Gestion/PaymentCalendar.vue")
    },
    {
        path: "/gestion/pagos",
        name: "GestionPagos",
        component: () => import("@/views/Gestion/List_Payments.vue")
    },
    {
        path: "/gestion/mensajes-whatsapp",
        name: "GestionMensajesWhatsApp",
        component: () => import("@/views/Gestion/List_WhatsApp_Messages.vue")
    },
    {
        path: "/gestion/ventas-vehiculos",
        name: "GestionVentasVehiculos",
        component: () => import("@/views/Gestion/List_Vehicle_Sales.vue")
    },
    {
        path: "/gestion/vehiculos/recuperados",
        name: "GestionVehiculosRecuperados",
        component: () => import("@/views/Gestion/List_Recovered_Vehicles.vue")
    },
    {
        path: "/gestion/citas-cobranza",
        name: "GestionCitasCobranza",
        component: () => import("@/views/Gestion/List_Collection_Appointments.vue")
    },
    // Nomencladores
    {
        path: "/nomencladores/categorias",
        name: "NomencladoresCategorias",
        component: () => import("@/views/Nomencladores/List_Categories.vue")
    },
    {
        path: "/nomencladores/marcas",
        name: "NomencladoresMarcas",
        component: () => import("@/views/Nomencladores/List_Brands.vue")
    },
    {
        path: "/nomencladores/modelos",
        name: "NomencladoresModelos",
        component: () => import("@/views/Nomencladores/List_Models.vue")
    },
    {
        path: "/nomencladores/paises",
        name: "NomencladoresPaises",
        component: () => import("@/views/Nomencladores/List_Countries.vue")
    },
    {
        path: "/nomencladores/estados",
        name: "NomencladoresEstados",
        component: () => import("@/views/Nomencladores/List_States.vue")
    },
    {
        path: "/nomencladores/banners",
        name: "NomencladoresBanners",
        component: () => import("@/views/Nomencladores/List_Banners.vue")
    },
    {
        path: "/nomencladores/faqs",
        name: "NomencladoresFAQs",
        component: () => import("@/views/Nomencladores/List_FAQs.vue")
    },
    // Configuración
    {
        path: "/configuracion/tasas-cambio",
        name: "ConfiguracionTasasCambio",
        component: () => import("@/views/Configuracion/ExchangeRates.vue")
    },
    // Reportes
    {
        path: "/reportes",
        name: "Reportes",
        component: () => import("@/views/Reportes/Reports.vue")
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes,
    linkActiveClass: "active"
});
router.beforeEach((to, from, next) => {
    const publicPages = ["/login"];
    const authRequired = !publicPages.includes(to.path);
    
    // Función para obtener token del nuevo sistema
    const getAuthToken = () => {
        try {
            // Primero intentar localStorage (persiste entre actualizaciones)
            let authDataStr = localStorage.getItem("authData");
            
            // Si no está en localStorage, intentar sessionStorage
            if (!authDataStr) {
                authDataStr = sessionStorage.getItem("authData");
            }
            
            if (authDataStr) {
                const authData = JSON.parse(authDataStr);
                
                // Verificar si el token no ha expirado
                if (authData.expiresAt && Date.now() > authData.expiresAt) {
                    localStorage.removeItem("authData");
                    sessionStorage.removeItem("authData");
                    return null;
                }
                return authData.token;
            }
            
            // Fallback para compatibilidad
            const oldToken = sessionStorage.getItem("token") || localStorage.getItem("token");
            return oldToken;
        } catch (error) {
            console.error("Error getting auth token:", error);
            return null;
        }
    };
    
    const token = getAuthToken();

    // Si vamos a login y ya estamos autenticados, redirigir al dashboard
    if (to.path === "/login" && token) {
        next("/dashboard");
        return;
    }

    // Si la ruta requiere autenticación y no tenemos token, ir a login
    if (authRequired && !token) {
        next("/login");
        return;
    }

    // En todos los demás casos, continuar
    next();
});
export default router;
